module.exports = __webpack_public_path__ + "static/assets/d53b0d8b2957e19ba694e3a6cd7fd5ca.svg";